import React from 'react';
import PropTypes from 'prop-types';

import { bemGenerator } from '@prisjakt/ui-base';

import './index.scss';

const styles = bemGenerator('pj-deal-placeholder', [
  'text',
  'media',
  'deal',
  'rows',
]);

const Placeholder = ({ amount, mode, rows, height, mediaPosition }) => (
  <div className={styles.block}>
    {[...new Array(amount)].map((e, i) => (
      <span
        key={i.toString()}
        style={{ height }}
        className={styles.deal.withModifier({ [mode]: true })}
      >
        <span
          style={{ order: mediaPosition }}
          className={styles.media.withModifier({ [mode]: true })}
        />

        {mode === 'row' && (
          <div className={styles.rows.withModifier({ [mode]: true })}>
            {[...new Array(rows)].map((row, rowIndex) => (
              <span key={rowIndex.toString()} className={styles.text} />
            ))}
          </div>
        )}

        {mode === 'grid' &&
          [...new Array(rows)].map((row, rowIndex) => (
            <span
              key={rowIndex.toString()}
              style={{ order: rowIndex + 1 }}
              className={styles.text}
            />
          ))}
      </span>
    ))}
  </div>
);

Placeholder.propTypes = {
  amount: PropTypes.number,
  mode: PropTypes.oneOf(['grid', 'row']),
  rows: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mediaPosition: PropTypes.number,
};

Placeholder.defaultProps = {
  amount: 1,
  rows: 5,
  mode: 'grid',
  height: 'auto',
  mediaPosition: 0,
};

export default Placeholder;
